export default {
    computed: {
        endpoints () {
            return window.endpoints;
        }
    }
}
